<script>
import HeaderWithTitleAndIcon from "@/components/HeaderWithTitleAndIcon.vue";
import {mapActions} from "vuex";

export default {
  name: 'AdminLoginView',
  components: {HeaderWithTitleAndIcon},
  data () {
    return {
      username: '',
      password: '',
      submitting: false
    }
  },
  methods: {
    ...mapActions('Auth', ['loginAction']),
    async handleSubmit () {
      if (!this.username || !this.password) {
        return
      }
      this.submitting = true
      try {
        await this.loginAction({username: this.username, password: this.password})
        const redirect = this.$route.query.redirect || '/admin'
        await this.$router.push(redirect)
      } catch (error) {
        // 錯誤訊息已經由 request.js 的攔截器 Toast 出來了，這裡不用重複顯示
      } finally {
        this.submitting = false
      }
    }
  }
}
</script>

<template>
  <div class="admin-login">
    <header-with-title-and-icon>
      <template #header-title>
        Admin Login
      </template>
    </header-with-title-and-icon>
    <form class="login-form" @submit.prevent="handleSubmit">
      <label class="field">
        <span>Username</span>
        <input v-model="username" type="text" autocomplete="username" required>
      </label>
      <label class="field">
        <span>Password</span>
        <input v-model="password" type="password" autocomplete="current-password" required>
      </label>
      <button type="submit" :disabled="submitting">
        {{ submitting ? 'Logging in...' : 'Login' }}
      </button>
    </form>
  </div>
</template>

<style scoped lang="less">
.admin-login {
  max-width: 400px;
  margin: 20px auto;
  padding: 0 20px;

  .login-form {
    display: flex;
    flex-direction: column;
    gap: 16px;

    .field {
      display: flex;
      flex-direction: column;
      gap: 6px;

      input {
        padding: 0.6rem;
        border: 1px solid var(--gray);
        border-radius: 3px;
        font-size: 1rem;
      }
    }

    button {
      padding: 0.7rem;
      border: none;
      border-radius: 3px;
      background-color: var(--blue);
      color: var(--white);
      font-size: 1rem;
      cursor: pointer;

      &:hover:not(:disabled) {
        background-color: var(--blueHover);
      }

      &:disabled {
        cursor: not-allowed;
        opacity: 0.6;
      }
    }
  }
}
</style>
